import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { AuthGuard } from "./components/AuthGuard";
import { LoginPage } from "./pages/LoginPage";
import { SetupPage } from "./pages/SetupPage";
import { ArchivPage, InboxPage, ZuletztPage } from "./pages/ArchivPage";
import { ReceiptDetailPage } from "./pages/ReceiptDetailPage";
import { AuswertungenPage } from "./pages/AuswertungenPage";
import { DrillDownPage } from "./pages/DrillDownPage";
import { TagsPage } from "./pages/PlaceholderPages";
import { EinstellungenPage } from "./pages/EinstellungenPage";
import { KartenPage } from "./pages/KartenPage";
import { VertraegePage } from "./pages/VertraegePage";
import { ByDtPage } from "./pages/ByDtPage";
import { BuchungenPage } from "./pages/BuchungenPage";
import { KontenPage } from "./pages/KontenPage";
import { AbgleichPage } from "./pages/AbgleichPage";
import { HaendlerPage } from "./pages/HaendlerPage";
import { SteuerPage } from "./pages/SteuerPage";
import { PrueflistePage } from "./pages/PrueflistePage";
import { JahreswertePage } from "./pages/JahreswertePage";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/setup" element={<SetupPage />} />

      <Route
        element={
          <AuthGuard>
            <AppShell />
          </AuthGuard>
        }
      >
        <Route index element={<Navigate to="/inbox" replace />} />
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="/zuletzt" element={<ZuletztPage />} />
        <Route path="/archiv" element={<ArchivPage />} />
        <Route path="/receipts/by-dt/:uuid" element={<ByDtPage />} />
        <Route path="/receipts/:id" element={<ReceiptDetailPage />} />
        <Route path="/auswertungen" element={<AuswertungenPage />} />
        <Route path="/auswertungen/liste" element={<DrillDownPage />} />
        <Route path="/tags" element={<TagsPage />} />
        <Route path="/einstellungen" element={<EinstellungenPage />} />
        <Route path="/einstellungen/karten" element={<KartenPage />} />
        <Route path="/einstellungen/vertraege" element={<VertraegePage />} />
        <Route path="/einstellungen/konten" element={<KontenPage />} />
        <Route path="/einstellungen/haendler" element={<HaendlerPage />} />
        <Route path="/buchungen" element={<BuchungenPage />} />
        <Route path="/buchungen/abgleich" element={<AbgleichPage />} />
        <Route path="/steuer" element={<SteuerPage />} />
        <Route path="/pruefliste" element={<PrueflistePage />} />
        <Route path="/einstellungen/jahreswerte" element={<JahreswertePage />} />
      </Route>

      <Route path="*" element={<Navigate to="/inbox" replace />} />
    </Routes>
  );
}
